import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_total_days_were_wrkrs_on_strike_for_all_strikes_during'

export const dataPointDefinition = {
  retracedId: 'how_many_total_days_were_wrkrs_on_strike_for_all_strikes_during',
  name: 'How many total days were workers on strike (for all strikes during the assessment period):',
  description:
    'When calculating the number of days, include all strikes recorded. Round to the nearest half-day. Fractions of a day equal to or less than 5 hours should be rounded to 0.5. Fractions of a day greater than 5 hours should be rounded to a day. Use the rounded figure to calculate the number of person days.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-56',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12530,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
